import React from 'react';
import classNames from 'classnames';
import ExtendSearchBase from './ExtendSearchBase';
import { Select, Checkbox } from '../../Controls';
import { RENT, APARTMENTS } from '../../../consts';
import { getAgencies } from '../../../utils/dictionaries';

class RentApartments extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'rentApartments';
    const dic = props.dictionary;

    this.buildingTypeItems = dic.getBuildingTypeItems(RENT, APARTMENTS);
    this.rentPeriodItems = dic.getRentPeriodItems(RENT, APARTMENTS);
    this.genderItems = dic.getGenderItems(RENT, APARTMENTS);
    this.personNumberItems = dic.getPersonNumberItems(RENT, APARTMENTS);
    this.renovationTypeItems = dic.getRenovationTypeItems(RENT, APARTMENTS);
    this.furnitureTypeItems = dic.getFurnitureTypeItems(RENT, APARTMENTS);
    this.trinityYesNoItems = dic.getTrinityYesNoItems();
    this.trinityExistNoItems = dic.getTrinityExistNoItems();
    this.planningItems = dic.getPlanningItems(RENT, APARTMENTS);
    this.applicationItems = dic.getApplicationItems(RENT, APARTMENTS);
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }

  renderPanel () {
    return (<div>
      <div className='filter-section__container'>
        <h3 className='title'>Параметры квартиры</h3>

          <div className='container__row'>
            <div className='container__column'>
              {this.renderInputGroup('Общая площадь, м²', null, [
                {name: 'squareTotalMin', placeholder: 'От', handler: this.getHandlerFloat('squareTotalMin', 7)},
                {name: 'squareTotalMax', placeholder: 'До', handler: this.getHandlerFloat('squareTotalMax', 7)}
              ])}
              {this.renderInputGroup('Жилая площадь, м²', null, [
                {name: 'squareLivingMin', placeholder: 'От', handler: this.getHandlerFloat('squareLivingMin', 7)},
                {name: 'squareLivingMax', placeholder: 'До', handler: this.getHandlerFloat('squareLivingMax', 7)}
              ])}
              {this.renderInputGroup('Площадь кухни, м²', null, [
                {name: 'squareKitchenMin', placeholder: 'От', handler: this.getHandlerFloat('squareKitchenMin', 7)},
                {name: 'squareKitchenMax', placeholder: 'До', handler: this.getHandlerFloat('squareKitchenMax', 7)}
              ])}
            </div>
            <div className='container__column'>
              {this.renderMultiSelect('Планировка', 'planningId', this.planningItems)}
              {this.renderMultiSelect('Состояние / ремонт', 'renovationTypeId', this.renovationTypeItems, true)}
              {this.renderMultiSelect('Мебель', 'furnitureId', this.furnitureTypeItems, true)}
            </div>
            <div className='container__column'>
              <div className='container__row'>
                <div className='house-type__element'>
                  {this.renderMultiSelect('Тип дома', 'buildingTypeId', this.buildingTypeItems, true)}
                </div>
                <div className='house-type__element house-type__checkbox'>
                  {this.renderControlGroup('', (
                    <div>
                      <Checkbox
                        label='Только новые дома'
                        checked={this.getFilter('isNewBuilding')}
                        onUpdate={(_, state) => this.setFilter('isNewBuilding', state ? 1 : null)}
                      />
                    </div>
                ))}
                </div>
              </div>
              {this.renderControlGroup('Удобства', (
                <div>
                  <Checkbox
                    label='Холодильник'
                    checked={this.getFilter('hasFridge')}
                    onUpdate={(_, state) => this.setFilter('hasFridge', state ? 1 : null)}
                  />
                  <Checkbox
                    label='Телевизор'
                    checked={this.getFilter('hasTV')}
                    onUpdate={(_, state) => this.setFilter('hasTV', state ? 1 : null)}
                  />
                  <Checkbox
                    label='Стиральная машина'
                    checked={this.getFilter('hasWashingMachine')}
                    onUpdate={(_, state) => this.setFilter('hasWashingMachine', state ? 1 : null)}
                  />
                  <Checkbox
                    label='Кондиционер'
                    checked={this.getFilter('hasConditioning')}
                    onUpdate={(_, state) => this.setFilter('hasConditioning', state ? 1 : null)}
                  />
                  <Checkbox
                    label='Балкон/Лоджия'
                    checked={this.getFilter('hasBalcony')}
                    onUpdate={(_, state) => this.setFilter('hasBalcony', state ? 1 : null)}
                  />
                </div>
              ))}
            </div>
          </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Условия сделки</h3>
          <div className='container__row'>
              <div className='container__column'>
                {this.renderControlGroup('Период сдачи в аренду', (
                  <Select
                    name='rentPeriodId'
                    items={this.rentPeriodItems}
                    value={this.getFilter('rentPeriodId')}
                    scrolling
                    onUpdate={(_, id) => this.setFilter('rentPeriodId', id)}
                  />
                ))}

                {this.renderControlGroup('', (
                  <div>
                    <Checkbox
                      label='Коммунальные услуги входят в стоимость аренды'
                      checked={this.getFilter('includedUtilities')}
                      onUpdate={(_, state) => this.setFilter('includedUtilities', state ? 1 : null)}
                    />
                    <br />
                    <Checkbox
                      label='Депозит'
                      checked={this.getFilter('needDeposit')}
                      onUpdate={(_, state) => this.setFilter('needDeposit', state ? 1 : null)}
                    />
                  </div>
                ))}
              </div>
              <div className='container__column'>
                {this.renderGroupPills(
                  'tenantGenderPreferenceId',
                  'btn-group-gender-preference',
                  'Предпочтение к жильцам',
                  'Мужчины',
                  'Женщины'
                  )
                }
                {this.renderGroupPills(
                  'tenantCountPreferenceId',
                  'btn-group-count-preference',
                  'Кол-во человек',
                  'Только один',
                  'Не более двух'
                  )
                }
              </div>
              <div className='container__column'>
                {this.renderControlGroup('Дополнительно', (
                  <div>
                    <Checkbox
                      label='Можно с детьми'
                      checked={this.getFilter('isChildrenAllowed')}
                      onUpdate={(_, state) => this.setFilter('isChildrenAllowed', state ? 1 : null)}
                    />
                    <br />
                    <Checkbox
                      label='Можно с животными'
                      checked={this.getFilter('isAnimalsAllowed')}
                      onUpdate={(_, state) => this.setFilter('isAnimalsAllowed', state ? 1 : null)}
                    />
                  </div>
                ))}
              </div>
          </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>
          <div className='container__row'>
            <div className='container__column'>
              {this.getUserIsAdmin() && this.renderMultiSelect('Приложения', 'sourceAppId', this.applicationItems, true)}
              {this.renderInputGroup('Поиск в описании', null, [
                {name: 'description', placeholder: 'ключевые слова', handler: this.getHandlerString('description')}
              ])}
            </div>
            <div className='container__column'>
              {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
              {this.renderInputGroup('Контактный телефон', null, [
                {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
              ])}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Номер объявления', null, [
                {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
              ])}
              {this.renderControlGroup('Дополнительно', (
                <div>
                  <Checkbox
                    label='Без комиссии'
                    disabled={this.getFilter('isMls')}
                    checked={this.getFilter('onlyOwners')}
                    onUpdate={(_, state) => {
                      const filter = {
                        onlyOwners: state ? 1 : null
                      };

                      if (state) {
                        filter.isMls = null;
                      }

                      this.setFilter(filter);
                    }}
                  />
                  <Checkbox
                    label='С фото'
                    checked={this.getFilter('hasPhoto')}
                    onUpdate={(_, state) => this.setFilter('hasPhoto', state ? 1 : null)}
                  />
                  {this.hasMls() && <Checkbox
                    label='МЛС'
                    checked={this.getBool('isMls')}
                    onUpdate={(_, state) => this.handlerMls(_, state)}
                  />}
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>);
  }
}

export default RentApartments;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/RentApartments.jsx